<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 200"
          :title="alertTitle"
          type="success"
          effect="dark"
        >
        </el-alert>
        <div class="row m-4">
          <div class="col-md-2">
            <h4>Разделы FAQ</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('faq-section/create')"
              >Добавить раздел</el-button
            >
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="8">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input
                    v-model="query.q"
                    @input="(e) => searchSections(e)"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Сортировка">
                <el-select
                  ref="selectSort"
                  :value="query.sort.by + '.' + query.sort.order"
                  :width="300"
                  @change="(e) => sortSections(e)"
                >
                  <el-option
                    value="title.asc"
                    label="Название (А-Я)"
                  ></el-option>
                  <el-option
                    value="title.desc"
                    label="Название (Я-А)"
                  ></el-option>
                  <el-option
                    value="sort.asc"
                    label="Cортировка по возрастанию"
                  ></el-option>
                  <el-option
                    value="sort.desc"
                    label="Cортировка по убыванию"
                  ></el-option>
                  <el-option
                    value="activity.asc"
                    label="Активность по возрастанию"
                  ></el-option>
                  <el-option
                    value="activity.desc"
                    label="Активность по убыванию"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="sections" empty-text="Нет данных" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50"> </el-table-column>
          <el-table-column prop="title" label="Название"> </el-table-column>
          <!-- <el-table-column prop="slug" label="Slug"> </el-table-column> -->
          <el-table-column prop="faqs_count" label="Количество вопросов">
            <template slot-scope="scope">
              <p>{{ sections[scope.$index].faq_quantity }}</p>
            </template>
          </el-table-column>
          <el-table-column label="Иконка">
            <template slot-scope="scope">
              <img
                style="height: 20px; width: 20px"
                :src="icons.find((el) => el.id === sections[scope.$index].icon_id).path"
              />
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="Сортировка"> </el-table-column>
          <el-table-column label="Активность">
            <template slot-scope="scope">
              <p v-if="!sections[scope.$index].activity">Нет</p>
              <p v-if="sections[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="400">
            <template slot-scope="scope">
              <div class="faq-section__nav">
                <el-button
                  v-if="sections[scope.$index].activity"
                  size="mini"
                  type="primary"
                  plain
                  @click="(e) => hideRow(sections[scope.$index].id, e)"
                >
                  Скрыть
                </el-button>
                <el-button
                  v-if="!sections[scope.$index].activity"
                  size="mini"
                  type="primary"
                  ref=""
                  plain
                  @click="(e) => restoreRow(sections[scope.$index].id, e)"
                >
                  Показать
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="(e) => openFAQSection(sections[scope.$index].id, e)"
                >
                  Редактировать
                </el-button>
                <el-popconfirm
                  :title="'Удалить этот раздел?'"
                  :hide-icon="true"
                  :confirmButtonText="'Да'"
                  :cancelButtonText="'Нет'"
                  @confirm="(e) => deleteRow(sections[scope.$index].id, e)"
                >
                  <template #reference>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      class="el-table__row--remove-btn"
                    >
                      Удалить
                    </el-button>
                  </template>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          v-show="paginator"
          background
          layout="prev, pager, next"
          :total="paginator ? paginator.total : 0"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="false"
          :page-size="paginator ? paginator.per_page : 0"
          :page-count="paginator ? paginator.last_page : 0"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import qs from 'qs';

export default {
  data: function () {
    return {
      status: 0,
      sections: [],
      paginator: null,
      current: 0,
      query: {
        q: null,
        sort: {
          by: "title",
          order: 'asc',
        },
        limit: 8,
      },
      timeoutSearch: null,
      alertType: null,
      selectSort: null,
      pageNumber: null,
      section: null,
      isCreateMode: null,
      isUpdateMode: null,
      searchTimeout: null,
      icons: [],
    };
  },
  mounted() {
    this.getSections();
  },
  methods: {
    getSections: function () {
      const queryParams = qs.stringify(this.query, { skipNulls: true })

      const getSections = axios.get(`/faq/section?${queryParams}`);
      const getIcons = axios.get('/icon');

      Promise.all([getSections, getIcons]).then((response) => {
        const [sections, icons] = response

        this.sections = sections.data.data;
        this.paginator = sections.data.meta;
        this.current = sections.data.meta.current_page;

        this.icons = icons.data
      }).catch((errors) => {
          if (errors.response?.status === 401) {
            this.$router.push("/login");
          }
      }).finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
      })
    },
    getSectionsData() {
      this.$store.commit(SETPRELOADER_STATE, true)

      const queryParams = qs.stringify(this.query, { skipNulls: true })

      axios
        .get(`faq/section?${queryParams}`)
        .then((response) => {
          this.$store.commit(SETPRELOADER_STATE, false);
          this.paginator = response.data.meta;
          this.sections = response.data.data;
          this.current = response.data.meta.current_page;
        })
        .catch(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    searchSections: function (value) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
          if (!value) this.query.q = null
          this.getSectionsData()
        }, 500);
    },
    sortSections: function (value) {
      this.query.sort.by = value.split('.')[0]
      this.query.sort.order = value.split('.')[1]

      this.getSectionsData()
    },
    getPage: function (page) {
      if (page !== null) {
        this.$store.commit(SETPRELOADER_STATE, true);

        const queryParams = qs.stringify(this.query, { skipNulls: true })

        axios
          .get(`/faq/section?page=${page}&${queryParams}`)
          .then((response) => {
            this.$store.commit(SETPRELOADER_STATE, false);

            this.paginator = response.data.meta;
            this.sections = response.data.data;
            this.current = response.data.meta.current_page;
          })
          .catch((errors) => {
            this.$store.commit(SETPRELOADER_STATE, false);

            if (errors.response.status === 401) {
              this.$router.push("/login");
            }
          });
      }

      this.success = "";
      return this.paginator.first_page_url;
    },
    goToPage: function (path) {
      this.$router.push(path);
    },
    getTarget(e) {
      const t = e.target;
      const isBtn = t.classList.contains("el-button");

      return isBtn ? t : t.parentNode;
    },
    deleteRow: function (id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .delete("faq/section/" + id)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.alertType = "delete";

          this.sections = [...this.sections.filter((el) => el.id !== id)];

          if (this.sections.length === this.query.limit - 1) {
            this.getSections()
          }
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    hideRow: function (id, e) {
      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("faq/section/" + id + "/hide")
        .then((response) => {
          this.status = response.status;
          this.alertType = "hide";

          this.sections = [
            ...this.sections.map((el) => {
              if (el.id === id) {
                el.activity = false;
              }

              return el;
            }),
          ];

          btn.style.pointerEvents = "all";
        })
        .catch((errors) => {
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    restoreRow: function (id, e) {
      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("faq/section/" + id + "/restore")
        .then((response) => {
          this.status = response.status;
          this.alertType = "restore";

          this.sections = [
            ...this.sections.map((el) => {
              if (el.id === id) {
                el.activity = true;
              }

              return el;
            }),
          ];

          btn.style.pointerEvents = "all";
        })
        .catch((errors) => {
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    openFAQSection(id, e) {
      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      this.$router.push(`/faq-section/${id}/update`);

      // const loader = setTimeout(() => {
      //   this.$store.commit(SETPRELOADER_STATE, true);
      // }, 400);

      // const getSection = axios.get(`faq/section/${id}`);
      // const getIcons = axios.get('/icon')

      // Promise.all([getSection, getIcons]).then((response) => {
      //   const [section, icons] = response

      //   this.section = section.data;
      //   this.isUpdateMode = true;

      //   this.$store.commit("faqSection", section.data);
      //   this.$store.commit('setGeneralIcons', icons.data);

      //   this.$router.push(`/faq-section/${id}/update`);
      // }).catch((errors) => {
      //     if (errors.response.status === 401) {
      //       this.$router.push("/login");
      //     }
      //   }).finally(() => {
      //   clearTimeout(loader);
      //   this.$store.commit(SETPRELOADER_STATE, false);

      //   btn.style.pointerEvents = "all";
      // })
    },
  },
  computed: {
    alertTitle() {
      const types = [
        {
          value: "restore",
          title: "Раздел успешно восстановлен",
        },
        {
          value: "hide",
          title: "Раздел скрыт",
        },
        {
          value: "delete",
          title: "Раздел удален",
        },
      ];

      const current = types.find((el) => el.value === this.alertType);

      return current ? current.title : "";
    },
  },
};
</script>

<style scoped>
.el-table__row--remove-btn {
  margin-left: 15px;
}

.faq-section__nav {
  display: flex;
  justify-content: space-around;
}
</style>
